import { useState } from "react";
import { useSelector } from "react-redux";
import { userInfoSelector } from "store/selector/user";
import StaticHeaderInfo from "components/pages/web/static/staticHeaderInfo";
import { Trans, useTranslation } from "react-i18next";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
} from "reactstrap";
import PhoneMessage from "assets/image/phoneMessage.png";
import Referral from "assets/image/referral.png";
import PersonLaptop from "assets/image/personLaptop.png";
import Dollar from "assets/image/dollar.png";
import { Link } from "react-router-dom";
import ReferralModal from "components/pages/web/home/frindReferral/modalReferral";
import "assets/styles/components/lists.scss";

const ShowMoreReferral = () => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const { referralToken } = useSelector(userInfoSelector);

  const Items = [
    {
      title: "Get a link or invitation code",
      text: "Register_in_CoinnikMarket",
      imgSrc: PersonLaptop,
      number: "1",
    },
    {
      title: "Send link or code to friends",
      text: "Link_register",
      imgSrc: PhoneMessage,
      number: "2",
    },
    {
      title: "Earn a steady income from transactions",
      text: "After_each_transaction",
      imgSrc: Dollar,
      number: "3",
    },
  ];

  const lists = [
    "Commission_all_transactions",
    "Aach_transaction",
    "Referral_Reward",
    "Criterion_for_registering",
    "There is no limit to the number of friends introduced by a referrer",
    "Referral_percentage",
    "Nobitex reserves the right to change the rules for introducing friends at any time at its discretion.",
  ];

  return (
    <div>
      <StaticHeaderInfo>
        <div className="title-style mb-5 mb-md-0">
          <span className="text-light fs-2 fw-bold ">
            {t("Earn money by inviting friends")}
          </span>
        </div>
      </StaticHeaderInfo>
      <Container>
        <Row className="py-3">
          <Col xs="12">
            <Card className="shadow none-padding mt-n5 mt-md-0">
              <CardBody>
                <Row>
                  <Col xs="12" sm="12" md="12" lg="7" xl="7">
                    <CardTitle>
                      <span className="title-bordre-bottom">
                        {t("Invite friends to Coinnik Market")}
                      </span>
                    </CardTitle>
                    <p className="my-4 text-secondary-two-light ">
                      {t("Invite_friends")}
                      <Trans i18nKey="Invite_friends_link">
                        By providing your "referral link" or "referral code" to
                        your friends and acquaintances and registering through
                        it,
                        <span className="text-warning-light">
                          30% of their transaction{" "}
                        </span>
                        fees will be instantly credited to your account.
                      </Trans>
                    </p>
                    <Button
                      size="md"
                      color="warning"
                      onClick={() => setModalOpen(!modalOpen)}
                    >
                      <Link
                        to={referralToken ? "#" : "/app/user/login"}
                        className="text-white"
                      >
                        {t("Get a friend invitation code")}
                      </Link>
                    </Button>
                    {referralToken && (
                      <ReferralModal
                        setModalOpen={setModalOpen}
                        modalOpen={modalOpen}
                      />
                    )}
                  </Col>
                  <Col xs="12" sm="12" md="12" lg="5" xl="5">
                    <img src={Referral} className="w-100" />
                  </Col>
                </Row>
                <div className="d-flex align-items-center justify-content-center py-5">
                  <span className="title-bordre-bottom mt-5">
                    {t("Three easy steps to invite friends")}
                  </span>
                </div>

                <Row>
                  {Items.map((item) => (
                    <Col xs="12" sm="12" md="12" lg="4" xl="4" className="">
                      <Content
                        imgSrc={item.imgSrc}
                        title={t(item.title)}
                        text={t(item.text)}
                        number={t(item.number)}
                      />
                    </Col>
                  ))}
                </Row>
                <Row className="pt-5">
                  <Col xs="12">
                    <span className="title-bordre-bottom">
                      {t("Rules for inviting friends")}
                    </span>
                    <div className="list bullet-point py-5 ">
                      <ul>
                        {lists.map((item) => (
                          <li>
                            <span className=" text-secondary-seven-light ">
                              {t(item)}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const Content = ({ imgSrc, title, text, number }: any) => (
  <div className="flex-column">
    <div className="d-flex justify-content-center pb-5">
      <img src={imgSrc} className="referral-img-height" alt="image" />
    </div>
    <div className="px-5 none-padding">
      <div className="fs-7 fw-medium text-secondary-seven-light ">
        <Badge className="rounded-circle  bg-warning-one fs-6">{number}</Badge>
        <span> {title}</span>
      </div>
      <p className="text-secondary-seven-light fs-6 mt-3 ">{text}</p>
    </div>
  </div>
);
export default ShowMoreReferral;
